import {ValueObject} from '@s-ui/domain'

export class CreateLoanIdTransactionsRequest extends ValueObject {
  /**
   * @param {String} adId
   * @param {Number} entry
   * @param {Number} fee
   * @param {Number} terms
   * @param {Boolean} withLifeInsurance
   * @param {Boolean} withGapInsurance
   **/

  static validate({adId, entry, fee, terms, withLifeInsurance, withGapInsurance, validationError}) {
    const getInvalidParam = param => param === undefined || param === null || param === ''
    if (getInvalidParam(adId)) throw validationError('adId is required')
  }
}
